import { createAction, createAsyncAction } from "typesafe-actions";

import type { UseStatisticsMapByListId } from "../../usage-statistics/types";
import type { SignalsContainer } from "../types";

export const fetchSignalsAsyncAction = createAsyncAction(
    "@@sales/signals/FETCH_SIGNALS_START",
    "@@sales/signals/FETCH_SIGNALS_SUCCESS",
    "@@sales/signals/FETCH_SIGNALS_FAILURE",
)<void, SignalsContainer, string | undefined>();

export const fetchRestCountriesSignalsSuccessAction = createAction(
    "@@sales/signals/FETCH_REST_COUNTRIES_SIGNALS_SUCCESS",
)<SignalsContainer>();

export const getSignalsUseAsyncAction = createAsyncAction(
    "@@sales/signals/GET_SIGNALS_USE_START",
    "@@sales/signals/GET_SIGNALS_USE_SUCCESS",
    "@@sales/signals/GET_SIGNALS_USE_FAILURE",
)<void, UseStatisticsMapByListId, string | undefined>();
